app.service('addressIntegrityValidator', function (loading, modal) {

	const defaultSettings = {
		cityName: '',
		zipCode: '',
		street: '',
		deliveryCityName: '',
		deliveryZipCode: '',
		deliveryAddressStreet: '',
		isInvoice: false,
		invoiceCityName: '',
		invoiceZipCode: '',
		invoiceAddressStreet: '',
		isAdditionalEntityInvoice: false,
		additionalEntityInvoiceCityName: '',
		additionalEntityInvoiceZipCode: '',
		additionalEntityInvoiceStreet: '',
		checkHomeAddress: false,
		containsTelecommunicationRelatedItems: false
	};

	function validateAddressIntegrity(data) {
		const requestData = $.extend({}, defaultSettings, data);

		return $.ajax({
			url: '/customer-account-validate-address-integrity.ltr',
			dataType: 'json',
			method: 'GET',
			data: requestData
		});
	}

	function showBlockModal(message) {
		loading.stop();
		modal.generate({
			id: 'modal-address-validate-block',
			header: false,
			content: $.trim(message || ''),
			buttons: [
				{
					text: 'Rozumiem',
					cssClass: 'btn-second js-close-modal'
				}
			]
		});
	}

	function showConfirmationModal(message, onConfirm) {
		loading.stop();
		modal.generate({
			id: 'adress-validate-modal',
			content: message || '',
			buttons: [
				{
					text: 'Tak',
					cssClass: 'btn-second',
					click: () => modal.close()
				},
				{
					text: 'Nie, idę dalej',
					cssClass: 'btn-fourth',
					click: function handleIgnoreAddressIntegrityIssuesClick() {
						loading.start();
						if (typeof onConfirm === 'function') {
							onConfirm();
						}
					}
				}
			]
		});
	}

	function handleRequestError() {
		loading.stop();
		modal.alert(
			'Przepraszamy, wystąpił problem podczas komunikacji z serwerem. ' +
			'Prosimy spróbować ponownie później. Jeśli problem będzie się powtarzał, ' +
			'skontaktuj się z działem obsługi klienta.'
		);
	}

	function validate(params) {

		loading.start();

		validateAddressIntegrity(params.data)
			.then(response => {
				if (!response) {
					handleRequestError();
					return;
				}

				const { blockNextStep, message = '' } = response;

				if (blockNextStep) {
					showBlockModal(message);
				} else if (message.trim() !== '') {
					showConfirmationModal(message, params.onSuccess);
				} else {
					params.onSuccess();
				}
			})
			.fail(handleRequestError);
	}

	return {
		validate
	};
});